import type { WorkflowItem } from "@/api/models"

export function canEditWorkflow(
  workflow: Pick<WorkflowItem, "visibility">,
  isWorkflowAdmin: boolean
): boolean {
  if (workflow.visibility === "shared") return false
  if (workflow.visibility === "personal") return true
  return isWorkflowAdmin
}

export function canFavoriteWorkflow(
  workflow: Pick<WorkflowItem, "visibility">,
  isWorkflowAdmin: boolean
): boolean {
  return canEditWorkflow(workflow, isWorkflowAdmin)
}

export function canScheduleWorkflow(
  workflow: Pick<WorkflowItem, "visibility">,
  isWorkflowAdmin: boolean
): boolean {
  if (workflow.visibility === "shared") return true
  return canEditWorkflow(workflow, isWorkflowAdmin)
}
